import { Box, Button, TextField, Typography } from '@mui/material'
import React, { useState } from 'react'
import { STRATEGY_PLAN_SECTIONS } from '../../constants'
import useAlert from '../../hooks/useAlert'

import { authedAxios } from '../../utils'

const EditPlan = ({ onSave, onCancel, plan: planProp, selectedIdentity }) => {
  const [plan, setPlan] = useState(
    planProp || {
      primaryObjective: '',
      strategy: '',
      tactics: '',
      marketingEfforts: '',
      peopleNeeded: '',
      education: '',
    }
  )

  return (
    <Box sx={{ flexGrow: 1 }}>
      {Object.keys(STRATEGY_PLAN_SECTIONS).map((key) => (
        <Box key={key} sx={{ mt: 1 }}>
          <Typography variant={'h6'}>{STRATEGY_PLAN_SECTIONS[key]}</Typography>
          <TextField
            value={plan[key]}
            fullWidth
            multiline
            rows={2}
            margin='dense'
            placeholder={STRATEGY_PLAN_SECTIONS[key]}
            onChange={(e) => {
              setPlan((prev) => ({ ...prev, [key]: e.target.value }))
            }}
          ></TextField>
        </Box>
      ))}

      <Box sx={{ display: 'flex', justifyContent: 'flex-end', mt: 1 }}>
        <Button sx={{ mr: 2 }} onClick={onCancel}>
          Cancel
        </Button>
        <Button onClick={() => onSave(plan)} variant={'contained'}>
          Save
        </Button>
      </Box>
    </Box>
  )
}

export default EditPlan
